import React from 'react';

// Modern dot-wave loader
export function DotPulseLoader({ text = 'Processing', className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="dot-pulse-loader">
      <div className="flex items-center gap-[3px]">
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--accent-indigo)] animate-[dotPulse_1.4s_ease-in-out_0s_infinite]" />
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--accent-indigo)] animate-[dotPulse_1.4s_ease-in-out_0.2s_infinite]" />
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--accent-indigo)] animate-[dotPulse_1.4s_ease-in-out_0.4s_infinite]" />
      </div>
      {text && <span className="text-xs opacity-50 animate-pulse">{text}</span>}
    </div>
  );
}

// Bar shimmer loader for page loading
export function BarShimmerLoader({ className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`} data-testid="bar-shimmer-loader">
      <div className="flex items-end gap-1 h-8">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="w-1 bg-[var(--accent-indigo)] rounded-full animate-[barPulse_1.2s_ease-in-out_infinite]"
            style={{ animationDelay: `${i * 0.15}s`, height: '100%' }}
          />
        ))}
      </div>
      <p className="text-xs opacity-40 tracking-wider">Loading...</p>
    </div>
  );
}

// Processing indicator for chat
export function ProcessingIndicator() {
  return (
    <div className="flex items-start gap-2" data-testid="processing-indicator">
      <div className="w-6 h-6 rounded-md bg-[var(--accent-indigo)]/10 flex items-center justify-center shrink-0 mt-0.5">
        <div className="w-3 h-3 rounded-full border-2 border-[var(--accent-indigo)] border-t-transparent animate-spin" />
      </div>
      <div className="bg-[var(--surface-card)] border border-[var(--surface-border)] rounded-lg p-3 max-w-[300px]">
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-[3px]">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--accent-indigo)] animate-[dotPulse_1.4s_ease-in-out_0s_infinite]" />
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--accent-indigo)] animate-[dotPulse_1.4s_ease-in-out_0.2s_infinite]" />
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--accent-indigo)] animate-[dotPulse_1.4s_ease-in-out_0.4s_infinite]" />
          </div>
          <span className="text-xs animate-pulse text-[var(--accent-indigo)]">Processing next step...</span>
        </div>
        <p className="text-[10px] opacity-30 mt-1">Thinking and generating response</p>
      </div>
    </div>
  );
}
